import { useState } from 'react';
import '../../styles/FGAdmin.scss';
import MfaManagement from './MfaManagement';

type SubPage = 'MFA Management';

const subPages: SubPage[] = ['MFA Management'];

const FGAdmin = () => {
    const [activePage, setActivePage] = useState<SubPage>('MFA Management');

    const renderPage = () => {
        switch (activePage) {
            case 'MFA Management':
                return <MfaManagement />;
            default:
                return null;
        }
    };

    return (
        <div className='fg-admin-wrapper'>
            <div className='fg-admin-header'>
                <h2>FG ADMIN</h2>
            </div>

            <div className='fg-admin-sub-nav'>
                {subPages.map(page => (
                    <button
                        key={page}
                        className={`fg-admin-sub-nav-btn${activePage === page ? ' active' : ''}`}
                        onClick={() => setActivePage(page)}
                    >
                        {page}
                    </button>
                ))}
            </div>

            {renderPage()}
        </div>
    );
};

export default FGAdmin;
